import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-left-pipe', 'ChevronLeftPipe', [["path",{"d":"M7 6v12"}],["path",{"d":"M18 6l-6 6l6 6"}]]);